import { jsx as _jsx } from "react/jsx-runtime";
import { usePage } from '@inertiajs/react';
export function withInertiaPage(Component) {
    return (props) => {
        const page = usePage();
        return _jsx(Component, { ...props, page: page });
    };
}
